import React from "react";
import { Link } from "react-router-dom";
import { blogData } from "../data/data";

export default function Blogs(){
    // Add the new project to the existing data
    const projectsData = [
        ...blogData,
      
    ];

    return(
        <section className="relative py-16 lg:py-24 bg-white dark:bg-slate-900" id="blog">
            <div className="container relative">
                {/* Header Section */}
                <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
                    <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 dark:bg-teal-900/20 rounded-full border border-teal-200 dark:border-teal-800 mb-4">
                        <span className="text-teal-600 dark:text-teal-400 text-sm font-semibold uppercase tracking-wider">OUR WORK</span>
                    </div>
                    <h3 className="font-bold text-3xl lg:text-4xl text-slate-900 dark:text-white mb-4">
                        Completed Projects Highlights
                    </h3>
                    <p className="text-slate-600 dark:text-slate-400 text-lg leading-relaxed">
                        Explore our portfolio of completed projects that showcase our commitment to innovation, quality, and delivering tailored solutions to meet diverse needs. Each project reflects our expertise and dedication to excellence.
                    </p>
                </div>

                {/* Projects Grid - 4 columns on large screens */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
                    {projectsData.map((item, index) => {
                        return(
                            <div className="group relative overflow-hidden" key={index}>
                                {/* Image Container */}
                                <div className="relative overflow-hidden rounded-2xl shadow-lg dark:shadow-gray-800 group-hover:shadow-xl dark:group-hover:shadow-gray-700 transition-all duration-500">
                                    <img 
                                        src={item.image} 
                                        className="w-full h-60 object-cover group-hover:scale-110 transition-transform duration-500 ease-out" 
                                        alt={item.title}
                                    />
                                    {/* Gradient Overlay */}
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                                    
                                    {/* Category Badge */}
                                
                                </div>

                                {/* Content */}
                                <div className="mt-6">
                                    <Link 
                                        to="" 
                                        className="text-md font-bold  text-green-900 dark:text-white hover:text-teal-500 dark:hover:text-teal-400 transition-colors duration-300 line-clamp-2 leading-tight block"
                                        >
                                        {item.title}
                                    </Link>

                                    {/* View Project Link */}
                                   
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>
        </section>
    )
}